//src/components/common/Navbar.jsx
import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/myassessment.ai_logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaChevronDown,
  FaSignOutAlt,
  FaTags,
  FaUserCircle,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import useAuth from "../../hooks/useAuth";

const Navbar = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Path checks
  const isLandingPage = location.pathname === "/";
  const isProfilePage = location.pathname === "/profile";
  const isBuyPage = location.pathname === "/buy_items";
  const isProductPage = location.pathname === "/products";
  const isPricingPage = location.pathname === "/pricing";
  const istalktousPage = location.pathname === "/talktous";
  const isTermsAndPolicyPage = location.pathname === "/termsAndPolicy";

  // State management
  // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Refs
  // const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);

  // (Dropdown logic removed safely — keeping structure intact)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const loginHandler = () => navigate("/login_register");

  // const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  // const openProfile = () => {
  //   if (!isProfilePage) {
  //     navigate("/profile");
  //     setIsDropdownOpen(false);
  //   }
  // };

  const openProfile = () => {
    if (!isProfilePage) {
      navigate("/profile");
    }
  };

  // const handleBuyAssessment = () => {
  //   if (!isBuyPage) {
  //     navigate("/buy_items");
  //     setIsDropdownOpen(false);
  //   }
  // };

  const handleBuyAssessment = () => {
    if (!isBuyPage) {
      navigate("/buy_items");
    }
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-lg bg-white/70 border-b border-gray-200 shadow-sm px-4 md:px-10 lg:px-16 py-3 flex justify-between items-center">
      
  
      <a href="/dashboard" className="flex items-center gap-2">
        <img
          src={logo}
          alt="MyAssessment.AI"
          className="h-10 md:h-12 object-contain"
        />
      </a>

   
      <div>
        {isLandingPage ||
        isProductPage ||
        isPricingPage ||
        istalktousPage ||
        isTermsAndPolicyPage ? (
          <div className="flex items-center gap-6">
            
    
            <div className="hidden md:flex items-center gap-10 font-medium text-gray-700">
              <Link to="/products" className="hover:text-indigo-600 transition">
                Product
              </Link>
              <Link to="/pricing" className="hover:text-indigo-600 transition">
                Pricing
              </Link>
              <Link to="/talktous" className="hover:text-indigo-600 transition">
                Talk To Us
              </Link>
            </div>

            <div className="md:hidden">
              <button onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? (
                  <FaTimes className="text-2xl text-gray-700" />
                ) : (
                  <FaBars className="text-2xl text-gray-700" />
                )}
              </button>
            </div>

  
            <button
              onClick={loginHandler}
              className="bg-gradient-to-l from-indigo-950 to-indigo-800 text-white px-5 py-2 rounded-full text-sm md:text-base shadow-md hover:scale-105 transition"
            >
              Login / Register
            </button>

            {isMobileMenuOpen && (
              <div
                ref={mobileMenuRef}
                className="absolute top-16 right-4 w-52 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden"
              >
                <Link
                  to="/products"
                  className="block px-5 py-3 hover:bg-gray-50"
                  onClick={toggleMobileMenu}
                >
                  Product
                </Link>
                <Link
                  to="/pricing"
                  className="block px-5 py-3 hover:bg-gray-50"
                  onClick={toggleMobileMenu}
                >
                  Pricing
                </Link>
                <Link
                  to="/talktous"
                  className="block px-5 py-3 hover:bg-gray-50"
                  onClick={toggleMobileMenu}
                >
                  Talk To Us
                </Link>
              </div>
            )}
          </div>
        ) : (
          
        
          <div className="flex items-center gap-8 font-medium text-gray-700">
            
            <button
              onClick={openProfile}
              className="px-3 py-1 rounded-lg hover:bg-gray-100 transition flex items-center gap-2"
            >
              <FaUserCircle />
              Profile
            </button>

            <button
              onClick={handleBuyAssessment}
              className="px-3 py-1 rounded-lg hover:bg-gray-100 transition flex items-center gap-2"
            >
              <FaTags />
              Buy Assessment
            </button>

            <button
              onClick={logout}
              className="px-3 py-1 rounded-lg hover:bg-red-100 text-red-500 transition flex items-center gap-2"
            >
              <FaSignOutAlt />
              Logout
            </button>

          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;